import React, { useId, useState } from "react";
import RecipeStepList from "./RecipeListStep";
import BaseProgressBar from "base/BaseProgressBar";

const RecipeDirections = ({ recipe, headingLevel = 2 }) => {
  const [toggleDirectionFormat, setToggleDirectionFormat] = useState(true);

  const uniqueId = useId();
  const headingId = `${uniqueId}-directions-heading`;
  const contentId = `${uniqueId}-directions-content`;
  const Heading = `h${headingLevel}`;

  return (
    <section aria-labelledby={headingId}>
      <Heading id={headingId} className="p1">
        Directions
      </Heading>

      <div
        className="marg-t-1 Row"
        role="group"
        aria-label="Directions display format"
      >
        <div
          className="w-50 Justify-Center"
          id={toggleDirectionFormat ? "Div-Selected" : "Div-Not-Selected"}
        >
          <button
            type="button"
            onClick={() => setToggleDirectionFormat(true)}
            aria-pressed={toggleDirectionFormat}
            aria-controls={contentId}
          >
            <span
              className={
                toggleDirectionFormat
                  ? "Selected marg-0"
                  : "Not-Selected marg-0"
              }
            >
              List View
            </span>
          </button>
        </div>

        <div
          className="w-50 Justify-Center"
          id={!toggleDirectionFormat ? "Div-Selected" : "Div-Not-Selected"}
        >
          <button
            type="button"
            onClick={() => setToggleDirectionFormat(false)}
            aria-pressed={!toggleDirectionFormat}
            aria-controls={contentId}
          >
            <span
              className={
                !toggleDirectionFormat
                  ? "Selected marg-0"
                  : "Not-Selected marg-0"
              }
            >
              Card View
            </span>
          </button>
        </div>
      </div>

      <div id={contentId} className="Step">
        {toggleDirectionFormat ? (
          <div className="p1 marg-5">
            {recipe.steps.map((step) => (
              <RecipeStepList key={step.id} step={step} />
            ))}
          </div>
        ) : (
          <BaseProgressBar steps={recipe.steps} />
        )}
      </div>
    </section>
  );
};

export default RecipeDirections;
